/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import "antd/dist/antd.css";
import "./App.css";
import Layout from "./views/layout";
import { Provider } from "react-redux";
import store from "./redux/store";
import Admin from "./views/adminRouts";

import { BrowserRouter as Router, Switch } from "react-router-dom";
import { PrivateRoute } from "./components/PrivateRoute";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <PrivateRoute to="/">
            <Layout>
              {/* <CreateCompany /> */}
              <Admin />
            </Layout>
          </PrivateRoute>
        </Switch>
      </Router>
    </Provider>
  );
}
export default App;
